import React from "react";

const FeaturedCategories = ({
  categoriesList,
  handleSubmitSelection,
  handleShowAll,
  searchValue,
  showAll,
}) => {
  const handleOnClick = (value) => {
    handleSubmitSelection(value);
  };

  const optionsList = categoriesList
    .filter((category) => category.featured)
    .map((option) => {
      const selected =
        searchValue === option.value && !showAll ? "selected" : "";
      return (
        <li
          key={option.value}
          className={`tool__option tool__option--button ${selected}`}
          onClick={() => handleOnClick(option.value)}
        >
          {option.label}
        </li>
      );
    });

  return (
    <ul className="tool__options tool__options--search-categories">
      {optionsList}

      <li
        className={`tool__option tool__option--button ${showAll ? "selected" : ""}`}
        onClick={handleShowAll}
      >
        Show all
      </li>
    </ul>
  );
};

export default FeaturedCategories;
